import React from 'react';
import { Outlet, Link } from 'react-router-dom';  // Import Outlet and Link from react-router-dom

import DashboardFooter from '../components/DashboardFooter';
import InstallerHeader from 'components/InstallerHeader';
import InstallerSidebar from 'components/InstallerSidebar';

interface LayoutProps {
    children?: React.ReactNode;  // Make children optional as we are using Outlet
}

const InstallerLayout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div id="layout-wrapper">
      {/* Header component */}
      <InstallerHeader />
      
      {/* Sidebar component */}
      <InstallerSidebar />

      {/* Main content area */}
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
           
            {/* Render children or Outlet (child routes) */}
            {children ? children : <Outlet />}  {/* Render children if passed, else Outlet */}
          </div>
        </div>

        {/* Footer component */}
        <DashboardFooter />
      </div>
    </div>
  );
};

export default InstallerLayout;
